export default "__VITE_ASSET__CVbEtiCP__"